import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=4856eb92&lang=pug"
import script from "./Topic.vue?vue&type=script&lang=ts"
export * from "./Topic.vue?vue&type=script&lang=ts"
import style0 from "./Topic.vue?vue&type=style&index=0&id=4856eb92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports